import { requester } from "App";
import Dummy from "components/Dummy";
import P from "components/P";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DummyCard from "../main/DummyCard";
import MobilePuffuOrderCard from "../main/vending/mainPage/layout/process/card/MobilePuffuOrderCard";
import BackButton from "components/buttons/BackButton";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import CustomIcon from "components/icons/CustomIcon";
import Center from "layouts/wrapper/Center";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import VerticalFlex from "layouts/flex/VerticalFlex";
import TabView from "components/tabview/TabView";
import AllProductList from "./product/AllProductList";
import DeviceList from "./product/DeviceList";
import DisposableList from "./product/DisposableList";
import NormalType from "./product/NormalType";
import ModeType from "./product/ModeType";


function MobileProductlist() {
    const { id } = useParams();
    const [products, setProducts] = useState();
    const location = useLocation();
    const [cateogories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [isMounted, setMounted] = useState(false);
    const [filteredSubCategories, setFilteredSubCategories] = useState([]); // 하위카테고리
    const [filteredProducts, setFilteredProducts] = useState([]);
    const cartData = useSelector((state) => state.cart.products);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { storeId } = location.state || {};
    useEffect(() => {
        setMounted(true);
    }, [])
    console.log(id)
    useEffect(() => {
        if (isMounted) {
            let data = { storeCode: id }
            requester.findAllVendorProducts(data, (result) => {
                if (result.code === 0) {
                    const filterProducts = result.data.filter(p => p.categoryId == "6873ea91-b0ac-4fad-afee-fa3f13f41849");
                    setProducts(filterProducts);

                }
            })
            requester.openfindAllCategory((result) => {
                const filteredCategories = result.data.filter(category => category.id == "6873ea91-b0ac-4fad-afee-fa3f13f41849");
                setCategories(filteredCategories);
            })

        }
    }, [isMounted])

    const totalProducts = products && products.length;
    const dummyElementsCount = 4 - (totalProducts % 4);
    const dummyElements = products && Array.from({ length: dummyElementsCount }).map((_, index) => (
        <div key={`dummy-${index}`} style={{ flex: "1 1 20%", opacity: 0 }}>
            <DummyCard data={{}} />
        </div>
    ));

    const onCartClick = () => {
        navigate(`/ws/${id}/mobile/cart`);
    }

    const tabs = {
        allProducts: {
            label: '전체보기',
            content: <AllProductList storeId={storeId} />
        },
        device: {
            label: "기기",
            content: <DeviceList storeId={storeId}/>,
        },
        disposable: {
            label: '일회용',
            content: <DisposableList storeId={storeId}/>,
        },
        normalType: {
            label: '기성',
            content: <NormalType storeId={storeId}/>,
        },
        modeType: {
            label: '모드',
            content: <ModeType storeId={storeId}/>,
        },
    };

    return (
        <VerticalFlex gap={10} >
            <FlexChild>
                <TabView tabs={tabs} />
            </FlexChild>
            <FlexChild height={'10vh'} />
        </VerticalFlex>
    );
    return (

        <div>

            {/* <div
                style={{
                    position: "fixed",
                    top: 0,
                    zIndex: 99,
                    width: "100%",
                    height: "50px",
                    backgroundColor: "#F0F1F3"
                }}
            >
                <div style={{ width: "90%", margin: "0 auto", height: "50px" }}>
                    <HorizontalFlex>
                        <FlexChild width={"max-content"}>
                            <BackButton alignItems={"flex-start"} />
                        </FlexChild>
                        <FlexChild justifyContent={"center"}>
                            <P size={20} weight={700} font={"Pretendard"}>주문하기</P>

                        </FlexChild>
                        <FlexChild width={"max-content"}>
                            <div style={{position: "relative"}} onClick={onCartClick}>
                                <div style={{
                                    position: "fixed", 
                                    top: "10px", 
                                    right: "12px", 
                                    backgroundColor: "var(--point-color)", 
                                    width:"14px", 
                                    height: "14px", 
                                    borderRadius: "50%",
                                    display: "flex", 
                                    justifyContent: "center",
                                    alignItems: "center",
                                    zIndex: 100
                                    }}>
                                    <P color={"white"} size={10}>{cartData ? cartData.length : 0}</P>
                                </div>
                                <CustomIcon name={"statisticsCart"} width={"20px"} />
                            </div>
                        </FlexChild>

                    </HorizontalFlex>
                </div>
            </div>

            <div style={{ position: "fixed", top: "50px", zIndex: 99, backgroundColor: "white" }}>
                <HorizontalFlex justifyContent={"center"} padding={"10px 0"}>
                    {
                        cateogories &&
                        cateogories.map((data, index) => {
                            return (
                                <FlexChild width={"max-content"}>
                                    <div style={{ backgroundColor: "var(--point-color)", padding: "5px 15px", borderRadius: "5px" }}>
                                        <P color={"white"} font={"Pretendard"} weight={900}>기타</P>
                                    </div>
                                </FlexChild>
                            );
                        })
                    }
                </HorizontalFlex>
            </div>
            <Dummy height={"105px"} />
            <div
                style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    gap: "15px",
                    padding: "5px 15px"
                }}
            >
                {
                    products &&
                    products.map((data, index) => {
                        return (
                            <MobilePuffuOrderCard data={data} />
                        );
                    })
                }
                {totalProducts % 2 !== 0 && dummyElements}

            </div>
            <div style={{height: "10vh"}} /> */}
        </div>
    );
}

export default MobileProductlist;